var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamondShine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32209 3.73958L0.761719 2.19425L1.32657 1.63415L2.88695 3.17928L2.32209 3.73958ZM7.1194 2.56732V0.375H7.91106V2.56732H7.1194ZM12.6686 3.73958L12.119 3.17473L13.6643 1.6294L14.2292 2.19425L12.6686 3.73958ZM7.51523 14.625L1.50311 8.71798H13.5121L7.51523 14.625ZM4.63772 4.15066H10.3773L13.5014 7.92631H1.5138L4.63772 4.15066Z",
    fill: "#1A4CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondShine);
export default __webpack_public_path__ + "static/media/diamond_shine.b79e21b60c79a5b4ac1f5c02afe43db2.svg";
export { ForwardRef as ReactComponent };